(function(){
  function addBusinessDays(date, days){
    var result=new Date(date),count=0;
    while(count<days){result.setDate(result.getDate()+1);if(result.getDay()!==0)count++;}
    return result;
  }
  function initDelivery(root){
    if(root.dataset.p247Ready==="true")return;root.dataset.p247Ready="true";
    var input=root.querySelector("[data-p247-pincode]");
    var button=root.querySelector("[data-p247-delivery-check]");
    var result=root.querySelector("[data-p247-delivery-result]");
    if(!input||!button||!result)return;
    function show(message,state){result.textContent=message;result.className="p247-delivery__result "+(state||"");}
    function check(){
      var pin=String(input.value||"").replace(/\D/g,"").slice(0,6);input.value=pin;
      if(!/^[1-9][0-9]{5}$/.test(pin)){show("Please enter a valid 6-digit pincode.","is-error");return;}
      try{localStorage.setItem("userPincode",pin);}catch(e){}
      var prefix=pin.slice(0,3);
      var metro=["110","400","560","600","700","500","380","411"];
      var remote=["781","782","783","784","785","786","790","791","792","793","794","795","796","737","744","194","190"];
      var min=metro.indexOf(prefix)>-1?1:(remote.indexOf(prefix)>-1?4:2);
      var max=metro.indexOf(prefix)>-1?3:(remote.indexOf(prefix)>-1?7:4);
      var dispatch=new Date();if(dispatch.getHours()>=14)dispatch.setDate(dispatch.getDate()+1);while(dispatch.getDay()===0)dispatch.setDate(dispatch.getDate()+1);
      var options={day:"numeric",month:"short"};
      var from=addBusinessDays(dispatch,min).toLocaleDateString("en-IN",options);
      var to=addBusinessDays(dispatch,max).toLocaleDateString("en-IN",options);
      show("Estimated delivery: "+from+" – "+to+". Final serviceability is confirmed at checkout.","is-success");
    }
    input.addEventListener("input",function(){input.value=input.value.replace(/\D/g,"").slice(0,6);show("","");});
    input.addEventListener("keydown",function(e){if(e.key==="Enter"){e.preventDefault();check();}});
    button.addEventListener("click",check);
    try{var saved=localStorage.getItem("userPincode");if(saved){input.value=saved;check();}}catch(e){}
  }
  function initFilterSearch(){
    document.querySelectorAll('.collection-sidebar__group').forEach(function(group){
      if(group.dataset.p247FilterReady==='true')return;
      var list=group.querySelector('.tag-list');
      if(!list)return;
      var rows=Array.prototype.slice.call(list.querySelectorAll(':scope > .tag:not(.tag--remove)'));
      if(rows.length<12)return;
      group.dataset.p247FilterReady='true';
      var input=document.createElement('input');
      input.type='search';
      input.className='p247-filter-search';
      input.setAttribute('aria-label','Search filter options');
      input.placeholder='Search options';
      list.parentNode.insertBefore(input,list);
      input.addEventListener('input',function(){
        var q=input.value.toLowerCase().trim();
        rows.forEach(function(row){
          var label=(row.textContent||'').toLowerCase();
          row.classList.toggle('p247-filter-option-hidden',q!==''&&label.indexOf(q)===-1);
        });
      });
    });
  }
  function init(){
    document.querySelectorAll("[data-p247-delivery]").forEach(initDelivery);
    initFilterSearch();
  }
  document.addEventListener("DOMContentLoaded",init);
  document.addEventListener("shopify:section:load",init);
  document.addEventListener("shopify:section:reorder",init);
  document.addEventListener("ajaxProduct:loaded",init);
  document.addEventListener("collection:reloaded",function(){setTimeout(initFilterSearch,0);});
})();

/* Perfume24x7 wishlist — Phase 1 local-first, customer-sync ready */
(function(){
  if(window.P247Wishlist&&window.P247Wishlist.version)return;

  var STORAGE_KEY='p247_wishlist_v1';
  var ANON_KEY='p247_anonymous_id_v1';
  var MAX_ITEMS=100;
  var memoryState=null;
  var styleId='p247-wishlist-styles';

  function now(){return new Date().toISOString();}
  function makeId(){
    if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();
    return 'p247-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
  }
  function anonymousId(){
    try{
      var id=localStorage.getItem(ANON_KEY);
      if(!id){id=makeId();localStorage.setItem(ANON_KEY,id);}
      return id;
    }catch(e){return 'session-'+makeId();}
  }
  function emptyState(){return {version:1,anonymousId:anonymousId(),updatedAt:now(),items:[]};}
  function normalise(raw){
    if(!raw||typeof raw!=='object')return emptyState();
    if(!Array.isArray(raw.items))raw.items=[];
    raw.version=1;
    raw.anonymousId=raw.anonymousId||anonymousId();
    raw.updatedAt=raw.updatedAt||now();
    raw.items=raw.items.filter(function(item){return item&&item.productId;}).slice(0,MAX_ITEMS);
    return raw;
  }
  function read(){
    try{
      var raw=localStorage.getItem(STORAGE_KEY);
      memoryState=normalise(raw?JSON.parse(raw):emptyState());
      return memoryState;
    }catch(e){memoryState=memoryState||emptyState();return memoryState;}
  }
  function write(state){
    state=normalise(state);state.updatedAt=now();memoryState=state;
    try{localStorage.setItem(STORAGE_KEY,JSON.stringify(state));}catch(e){}
    syncButtons();
    document.dispatchEvent(new CustomEvent('p247:wishlist:changed',{detail:{count:state.items.length,items:state.items.slice(),anonymousId:state.anonymousId}}));
    return state;
  }
  function findIndex(state,productId){
    productId=String(productId||'');
    for(var i=0;i<state.items.length;i++){if(String(state.items[i].productId)===productId)return i;}
    return -1;
  }
  function has(productId){return findIndex(read(),productId)>-1;}
  function add(item){
    var state=read();
    if(findIndex(state,item.productId)>-1)return state;
    item.addedAt=item.addedAt||now();
    state.items.unshift(item);
    if(state.items.length>MAX_ITEMS)state.items.length=MAX_ITEMS;
    return write(state);
  }
  function remove(productId){
    var state=read();var index=findIndex(state,productId);
    if(index>-1)state.items.splice(index,1);
    return write(state);
  }
  function itemFromButton(button){
    var card=button.closest('[data-p247-collection-card]');
    var pdp=button.closest('.product-section[data-history="true"]');
    var root=card||pdp;
    var title='';var url='';var image='';var vendor='';var priceText='';
    if(card){
      title=((card.querySelector('.grid-product__title')||{}).textContent||'').trim();
      var link=card.querySelector('.p247-collection-card__link, .grid-product__link');
      url=link?link.href:'';
      var img=card.querySelector('img');image=img?(img.currentSrc||img.src||''):'';
      vendor=((card.querySelector('.grid-product__vendor')||{}).textContent||'').trim();
      priceText=((card.querySelector('.grid-product__price')||{}).textContent||'').replace(/\s+/g,' ').trim();
    }else if(pdp){
      title=pdp.getAttribute('data-product-title')||((pdp.querySelector('.product-single__title')||{}).textContent||'').trim();
      url=pdp.getAttribute('data-product-url')||window.location.href;
      var pimg=pdp.querySelector('[data-product-images] img, .product__main-photos img');image=pimg?(pimg.currentSrc||pimg.src||''):'';
      vendor=((pdp.querySelector('.product-single__vendor')||{}).textContent||'').trim();
      priceText=((pdp.querySelector('[data-product-price]')||{}).textContent||'').trim();
    }
    return {
      productId:String(button.getAttribute('data-product-id')||(root&&root.getAttribute('data-product-id'))||''),
      handle:button.getAttribute('data-product-handle')||(root&&root.getAttribute('data-product-handle'))||'',
      title:title,
      url:url,
      image:image,
      vendor:vendor,
      priceText:priceText,
      sourceContext:button.getAttribute('data-context')||'unknown'
    };
  }
  function track(action,item){
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({
      event:'p247_wishlist_'+action,
      p247_product_id:item.productId,
      p247_product_handle:item.handle||'',
      p247_wishlist_context:item.sourceContext||'',
      p247_wishlist_count:read().items.length
    });
  }
  function toast(message){
    var el=document.querySelector('[data-p247-wishlist-toast]');
    if(!el){el=document.createElement('div');el.className='p247-wishlist-toast';el.setAttribute('data-p247-wishlist-toast','');el.setAttribute('role','status');el.setAttribute('aria-live','polite');document.body.appendChild(el);}
    el.textContent=message;el.classList.add('is-visible');
    clearTimeout(el.__p247Timer);el.__p247Timer=setTimeout(function(){el.classList.remove('is-visible');},1700);
  }
  function toggle(button){
    var item=itemFromButton(button);if(!item.productId)return;
    if(has(item.productId)){remove(item.productId);track('remove',item);toast('Removed from wishlist');}
    else{add(item);track('add',item);toast('Saved to wishlist');}
  }
  function heartMarkup(){
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';
  }
  function createButton(productId,handle,context){
    var button=document.createElement('button');
    button.type='button';button.className='p247-wishlist-button p247-wishlist-button--'+context;
    button.setAttribute('data-p247-wishlist-button','');button.setAttribute('data-product-id',String(productId||''));
    button.setAttribute('data-product-handle',handle||'');button.setAttribute('data-context',context);
    button.setAttribute('aria-pressed','false');button.setAttribute('aria-label','Add to wishlist');button.title='Add to wishlist';
    button.innerHTML=heartMarkup();return button;
  }
  function injectPLP(root){
    (root||document).querySelectorAll('.p247-collection-card[data-p247-collection-card]').forEach(function(card){
      if(card.querySelector('[data-p247-wishlist-button]'))return;
      var button=createButton(card.getAttribute('data-product-id'),card.getAttribute('data-product-handle'),'plp');
      var content=card.querySelector('.p247-collection-card__content')||card;
      content.insertBefore(button,content.firstChild);
    });
  }
  function injectPDP(root){
    (root||document).querySelectorAll('.product-section[data-history="true"]').forEach(function(pdp){
      if(pdp.querySelector('[data-p247-wishlist-button]'))return;
      var header=pdp.querySelector('.product-block--header');var title=header&&header.querySelector('.product-single__title');
      if(!header||!title)return;
      var row=document.createElement('div');row.className='p247-pdp-title-row';title.parentNode.insertBefore(row,title);row.appendChild(title);
      row.appendChild(createButton(pdp.getAttribute('data-product-id'),pdp.getAttribute('data-product-handle'),'pdp'));
    });
  }
  function syncButtons(){
    var state=read();
    document.querySelectorAll('[data-p247-wishlist-button]').forEach(function(button){
      var active=findIndex(state,button.getAttribute('data-product-id'))>-1;
      button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',active?'true':'false');
      button.setAttribute('aria-label',active?'Remove from wishlist':'Add to wishlist');button.title=active?'Remove from wishlist':'Add to wishlist';
    });
  }
  function injectStyles(){
    if(document.getElementById(styleId))return;
    var css=[
      '.p247-collection-card__content{position:relative}',
      '.p247-wishlist-button{display:inline-grid;place-items:center;width:40px;height:40px;padding:0;border:1px solid var(--p247-stone,#ded8d1);border-radius:999px;background:rgba(255,255,255,.94);color:var(--p247-ink,#111);cursor:pointer;transition:color .18s ease,border-color .18s ease,background-color .18s ease,transform .18s ease}',
      '.p247-wishlist-button svg{width:19px;height:19px;fill:transparent;stroke:currentColor;stroke-width:1.7;transition:fill .18s ease,stroke .18s ease}',
      '.p247-wishlist-button:hover,.p247-wishlist-button:focus-visible{border-color:var(--p247-crimson,#e00034);color:var(--p247-crimson-700,#b4002a)}',
      '.p247-wishlist-button:focus-visible{outline:2px solid var(--p247-crimson-100,#ffdce4);outline-offset:2px}',
      '.p247-wishlist-button.is-active{border-color:var(--p247-crimson-100,#ffdce4);background:var(--p247-crimson-50,#fff0f3);color:var(--p247-crimson,#e00034)}',
      '.p247-wishlist-button.is-active svg{fill:currentColor;stroke:currentColor}',
      '.p247-wishlist-button--plp{position:absolute;z-index:6;top:10px;right:10px}',
      '.p247-pdp-title-row{display:flex;align-items:flex-start;justify-content:space-between;gap:14px}',
      '.p247-pdp-title-row .product-single__title{flex:1;min-width:0;margin-right:0}',
      '.p247-wishlist-button--pdp{flex:0 0 44px;width:44px;height:44px;margin-top:-3px}',
      '.p247-wishlist-button--pdp svg{width:21px;height:21px}',
      '.p247-wishlist-toast{position:fixed;z-index:10040;left:50%;bottom:24px;transform:translate(-50%,16px);max-width:calc(100vw - 32px);padding:10px 14px;border:1px solid var(--p247-stone,#ded8d1);border-radius:4px;background:#111;color:#fff;font-size:12px;line-height:1.35;opacity:0;pointer-events:none;transition:opacity .18s ease,transform .18s ease}',
      '.p247-wishlist-toast.is-visible{opacity:1;transform:translate(-50%,0)}',
      '@media(max-width:768px){.p247-wishlist-button--plp{top:7px;right:7px;width:38px;height:38px}.p247-wishlist-button--plp svg{width:18px;height:18px}.p247-pdp-title-row{gap:10px}.p247-wishlist-button--pdp{flex-basis:42px;width:42px;height:42px}.p247-wishlist-toast{bottom:calc(18px + env(safe-area-inset-bottom))}}'
    ].join('');
    var style=document.createElement('style');style.id=styleId;style.textContent=css;document.head.appendChild(style);
  }
  function initWishlist(root){injectStyles();injectPLP(root);injectPDP(root);syncButtons();}

  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-p247-wishlist-button]');if(!button)return;
    event.preventDefault();event.stopPropagation();toggle(button);
  },true);

  var observerTimer=null;
  var observer=new MutationObserver(function(mutations){
    var relevant=false;
    for(var i=0;i<mutations.length;i++){if(mutations[i].addedNodes&&mutations[i].addedNodes.length){relevant=true;break;}}
    if(!relevant)return;
    clearTimeout(observerTimer);observerTimer=setTimeout(function(){initWishlist(document);},80);
  });

  window.P247Wishlist={
    version:1,
    storageKey:STORAGE_KEY,
    getItems:function(){return read().items.slice();},
    getState:function(){return JSON.parse(JSON.stringify(read()));},
    has:has,
    add:add,
    remove:remove,
    toggle:function(productId){return has(productId)?remove(productId):null;},
    export:function(){return JSON.stringify(read());},
    clear:function(){var state=emptyState();write(state);return state;},
    syncButtons:syncButtons
  };

  function boot(){initWishlist(document);if(document.body)observer.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(event){initWishlist(event.target);});
  document.addEventListener('collection:reloaded',function(){setTimeout(function(){initWishlist(document);},0);});
  window.addEventListener('storage',function(event){if(event.key===STORAGE_KEY)syncButtons();});
})();